export enum ToastTypes {
    SET_TOAST_ACTIVE_STATE = 'SET_TOAST_ACTIVE_STATE',
    SET_TOAST_DESCRIPTION = 'SET_TOAST_DESCRIPTION',
    SET_TOAST_ICON = 'SET_TOAST_ICON'
}